import React, { ReactElement, useState, useEffect } from "react";
import { childrenNodeType } from "../../types";
import { useLocation } from "react-router-dom";

// Components
import Header from "../global/header/header";
import Footer from "../global/footer/footer";

const PrivateRouteLayout = ({ children }: childrenNodeType): ReactElement => {
  const location = useLocation();
  const [isLayoutVisible, setIsLayoutVisible] = useState(false);

  useEffect(() => {
    if (location.pathname === "/") {
      setIsLayoutVisible(false);
    } else {
      setIsLayoutVisible(true);
    }
  }, [location]);

  return (
    <>
      {!isLayoutVisible && <Header></Header>}

      {/* <!-- Main Wrapper - Start --> */}
      <main
        id="tm__wrapper"
        className={`flex-fill ${location.pathname === "/live" ? "h-100" : ""}`}>
        {children}
      </main>
      {/* <!-- Main Wrapper - End --> */}

      {!isLayoutVisible && <Footer></Footer>}
    </>
  );
};

export default PrivateRouteLayout;
